<template>
	<div>
		详情
	</div>
</template>
<script>
	module.exports=require('./View.js');
</script>


// WEBPACK FOOTER //
// View.vue?91de00fc